import { lazy } from 'react'

export const CreatingPlanV1 = lazy(() => import('./v1/CreatingPlanV1'))
export const CreatingPlanV2 = lazy(() => import('./v2/CreatingPlanV2'))
export const CreatingPlanV3 = lazy(() => import('./v3/CreatingPlanV3'))
export const CreatingPlanV4 = lazy(() => import('./v4/CreatingPlanV4'))
export const CreatingPlanV5 = lazy(() => import('./v5/CreatingPlanV5'))
